import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import SimpleLoader from "../components/ui/SimpleLoader";
import useLocalStorage from "../hooks/useLocalStorage";
import useTabPrevention from "../utils/usePreventTabs";
import { useAuth } from "./authContext";

interface ProtectedRouteProps {
    element: ReactNode;
  }

const ProtectedRoute = ({ element }: ProtectedRouteProps) => {
	const [ token, setToken ] = useLocalStorage('token', null);

  useTabPrevention();
  const { planData , isLoading} = useAuth();

  return  token ? planData?.isPlanActive ? element : <SimpleLoader/> : <Navigate to="/login" replace/>;
};

export default ProtectedRoute;
